import { BehaviorSubject } from 'rxjs';

import { Service } from '../../../symphony';

import { ISelectedTags } from '../global-interface';
import { IFlashMessageTypes } from '../../../shared/public/SlFlashMessage/SlFlashMessage';
import { IDiscussPostData, DiscussSearchResponseDataType, IDiscussReply } from '../../../api/public/discuss-api';

@Service()
export class SlDataService {
	public question$ = new BehaviorSubject<IDiscussPostData['post']>(null);

	public questionsList$ = new BehaviorSubject<DiscussSearchResponseDataType>(
		null,
	);

	public questionsListCount$ = new BehaviorSubject<number>(null);

	public isQuestionsListLoading$ = new BehaviorSubject<boolean>(false);

	public isMyQuestion$ = new BehaviorSubject<boolean>(false);

	public replies$ = new BehaviorSubject<IDiscussReply[]>(null);

	public isReplyFormOpen$ = new BehaviorSubject<boolean>(false);

	public isSaveReplyLoading$ = new BehaviorSubject<boolean>(false);

	public hotTodayTopics$ = new BehaviorSubject<DiscussSearchResponseDataType>(
		null,
	);

	public isVisibleCreateReplySuccessMessage$ = new BehaviorSubject<boolean>(
		false,
	);

	public isVisibleEditReplySuccessMessage$ = new BehaviorSubject<boolean>(
		false,
	);

	public notificationData$ = new BehaviorSubject<{
		message: string;
		type: IFlashMessageTypes;
	}>(null);

	public currentQuestionId = new BehaviorSubject<string>(null);

	public suggestedTags$ = new BehaviorSubject<ISelectedTags[]>([]);

	public postQuestionLoading$ = new BehaviorSubject<boolean>(false);

	public deleteQuestionLoading$ = new BehaviorSubject<boolean>(false);

	public deleteReplyLoading$ = new BehaviorSubject<boolean>(false);

	public showPostQuestionSuccessModal$ = new BehaviorSubject<boolean>(false);

	public showDeleteQuestionModal$ = new BehaviorSubject<boolean>(false);

	public showDeleteReplyModal$ = new BehaviorSubject<boolean>(false);

	public isQuestionPosted$ = new BehaviorSubject<boolean>(false);

	public isQuestionEdited$ = new BehaviorSubject<boolean>(false);

	public isQuestionDeleted$ = new BehaviorSubject<boolean>(false);

	public isQuestionNotExist$ = new BehaviorSubject<boolean>(false);

	public editingReplyId$ = new BehaviorSubject<number>(null);

	public deletingReplyId$ = new BehaviorSubject<number>(null);

	public editingReplyText$ = new BehaviorSubject<string>('');
}
